<template>
	<div class="mt-8 push-web-responsive-note">
		<v-card class="filter--container d-flex">
      <span class="d-flex flex-row inputMessageFilter">
        <input
          v-model="logsToEdit.message"
          type="text"
          placeholder="Mensagem"
          class="inputWidth"
        >
        <img class="imgResponsive" style="width:20px" src="../../../../static/images/message.svg">
      </span>
			<date-picker
				v-model="rangeDate"
				class="inputDate d-flex align-center"
				format="DD/MM/YYYY HH:mm"
				placeholder="De"
        input-class="removeBorder"
        type="datetime"
        lang="pt-Br"
				time-title-format="DD/MM/YYYY"
			>
			</date-picker>
      <date-picker
				v-model="rangeDateFinal"
				class="inputDate d-flex align-center"
				format="DD/MM/YYYY HH:mm"
				placeholder="Até"
        input-class="removeBorder"
        type="datetime"
				time-title-format="DD/MM/YYYY"
			>
			</date-picker>

			<div class="button-wrapper d-flex justify-space-between">
				<button
					@click="fecth"
          class="mr-5"
          :disabled="!disabled"
				>
					<clip-loader
						v-if="loading"
						:loading="loading"
						color="var(--white)"
						size="22px"
					/>
					<div
            v-if="!loading"
						class="button-wrapper--text"
						>
						<img src="../../../../static/images/search.svg">
						Buscar
					</div>
				</button>
				<button
					@click="clearForm"
          style="background: var(--white); border: 1px solid grey; color: var(--dark-grey)"
				>
					<clip-loader
						v-if="loadingClear"
						:loading="loadingClear"
						color="var(--black)"
						size="22px"
					/>
					<div
            v-if="!loadingClear"
						class="button-wrapper--text"
						>
						<img src="../../../../static/images/load.svg">
						Limpar
					</div>
				</button>
			</div>
		</v-card>

		<h4 style="fontSize: 20px" class="mt-12">Agendamentos</h4>
    <div v-if="!loadingData">
      <v-expansion-panels class="mt-5">
				<v-expansion-panel v-for="(item, index) in items" :key="index" class="mt-2 d-flex flex-column rounded-lg" height="59" id="expansion-item">
					<v-expansion-panel-header class="d-flex align-center" style="padding: 10px 2px; position: initial;">
						<span class="rounded borderLeft" style=""></span>
            <div class="d-flex align-center justify-space-between">
              <div class="responsiveItemName">
                <span class="ml-9 font-weight-black">{{item.title}}</span>
              </div>
              <div class="d-flex align-center justify-space-between">
                <span class="font-weight-black">Data do disparo:</span><span class="mr-9 ml-1">{{formatDate(item.dateAdded)}}</span>
                <span class="font-weight-black">Horário:</span><span class="mr-9 ml-1"> {{formatHour(item.dateAdded)}}</span>
                <div class="buttons_action">
                  <router-link to="/duplicate" class="mr-6">
                    <button
                      style="
                        border: 2px solid var(--grey-day-020);
                        height: 40px;
                        width: 40px;
                      "
                      class="b-4 d-flex justify-center align-center"
                      @click="setDuplicateForm(item)"
                    >
                      <img src="../../../../static/images/square.svg" />
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
					</v-expansion-panel-header>
					<v-expansion-panel-content class="ml-5 responsive-note">
            <div class="d-flex flex-column">
              <span class="font-weight-black mt-4">Conteúdo</span>
              <span style="word-break: break-word">{{item.message}}</span>
						</div>
            <div class="d-flex flex-column">
              <span class="font-weight-black mt-4">ChannelType</span>
              <span>{{item.channelType}}</span>
						</div>
						<div class="d-flex flex-row align-start mt-4">
							<span class="font-weight-black">Url do Redirect:</span>
							<span class="ml-2" style="word-break:break-word">{{item.url}}</span>
						</div>
					</v-expansion-panel-content>
				</v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div v-if="loadingData" class="mt-5 d-flex justify-center align-center rounded" style="background: var(--white); width: auto; height: 200px">
      <span>Dados não encontrados!</span>
    </div>
    
    <div v-if="items.length === 0 && !loadingData" class="mt-5 d-flex justify-center align-center rounded" style="background: var(--white); width: auto; height: 200px">
      <span>Nenhum registro encontrado!</span>
    </div>

    <!-- Pagination -->
    <v-card class="mt-8 mb-1">
      <div v-if="!loading" class="list-footer">
        <span></span>
        <v-pagination
          v-model="page"
          :length="numberPages"
          color="#F0F1F3"
          :total-visible="7"
          @input="nextPage"
        ></v-pagination>
        <div class="goToPage">
          <span class="goToPage--text"> Ir para página </span>
          <label>
            <input v-model="goToPage" type="text">
            <button
              @click="goToPageRequest"
              :disabled="disabledGoTo"
            >
              <div class="button-wrapper--text">
                <i class="iconStyle icon-arrow-right d-flex justify-center align-center"
                ></i>
              </div>
            </button>
            <span
              :class="
                showGoToPageHelpText ? '--show-helptext' : '--hide-helptext'
              "
              class="goToPage--helptext"
            >
              A página deve estar entre 1 e {{ numberPages }}
            </span>
          </label>
        </div>
      </div>
    </v-card>

    <div style="height: 5px"></div>
      
		<!-- Drwaer edit -->
		<v-navigation-drawer
      v-model="drawer"
      fixed
      overlay
      temporary
      right
      width="890"
      height="100vh"
      style="background: var(--grey-day-010)"
    >
			<EditPush v-on:close="drawer = false"/>
    </v-navigation-drawer>
	</div>
</template>
<script>
// Libs
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
import { mapActions, mapMutations, mapState } from "vuex";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import moment from 'moment'

//
import VueCookies from 'vue-cookies'

// Component
import EditPush from "./EditPush.vue";

//mixins
import date from '../../../mixins/date'
import toaster from '../../../mixins/toaster'

export default {
  mixins: [date, toaster],
  components: {
    DatePicker,
    ClipLoader,
    EditPush,
  },
  data() {
    return {
      disabled: false,
      loading: false,
      page: 1,
      goToPage: 1,
      disabledGoTo: false,
      showGoToPageHelpText: false,
      email: "",
      search_message: "",
      drawer: false,
      service: "",
      date: "",
      hasBorder: false,
      loadingClear: false,
      editForm: false,
      rangeDate: null,
      rangeDateFinal: null,
      loadingData: true,
    };
  },
  async created() {
    console.log('date', this.items[0])
    this.logsToEdit.message = ''
    await this.fecth()
  },
  computed: {
    ...mapState("Logs", {
      items: "items",
      totalElements: "totalElements",
      currentPage: "current_page",
      logsToEdit: "logsToEdit",
      totalPages: "totalPages",
      to: "to",
      from: "from",
    }),
    numberPages () {
      return this.totalPages
    },
    widthScreen() {
      return window.screen.width > 1377;
    },
  },
  methods: {
    ...mapActions("Logs", ["allLogs", "filterLogsPush"]),
    ...mapMutations("Logs", {
      setCurrentPage: "SET_CURRENT_PAGE",
      setLogsToEdit: "SET_LOGS_TO_EDIT",
      setChannel: "SET_CHANNEL",
      setSeachEmailFilter: "SET_SEARCH_EMAIL_FILTER",
      setSeachMessageFilter: "SET_SEARCH_MESSAGE_FILTER",
      setDateTo: "SET_DATE_TO",
      setDateFrom: "SET_DATE_FROM",
    }),
    async nextPage (e) {
      this.goToPage = this.page
      this.setCurrentPage(e - 1)
      await this.fecth()
    },
    buildFilter () {
      let filter = ''
      if (this.logsToEdit.message) filter += `&message=${this.logsToEdit.message}`
      if (this.rangeDate) filter += `&from=${moment(this.rangeDate).format('YYYY-MM-DD HH:mm')}` 
      if (this.rangeDateFinal) filter += `&to=${moment(this.rangeDateFinal).format('YYYY-MM-DD HH:mm')}`
      return filter
    },
    async fecth() {
      this.loadingData = true
      this.loading = true
      const token = VueCookies.get('jwt-login')
      const size = 15
      let filter = this.buildFilter()
      try {
				await this.filterLogsPush({
          size,
          filter,
          token
        })
        this.loading = false
        this.loadingData = false
        this.loading = false
        this.disabled = false
			}
			catch (error) {
        this.toaster(
          error.message,
          'var(--red)',
          true
        )
			}
    },
    async goToPageRequest() {
      this.loadingData = true;
      this.setCurrentPage(this.goToPage - 1);
      this.page = Number(this.goToPage)
      await this.fecth();
      this.loadingData = false;
    },
    async clearForm () {
      this.loadingClear = true
      this.logsToEdit.message = ''
      this.rangeDate = ''
      this.rangeDateFinal = ''
      this.setCurrentPage(0)
      const size = 15
      const filter = ''
      const token = VueCookies.get('jwt-login')
      this.goToPage = 1
      this.page = 1
      await this.filterLogsPush({
        size,
        filter,
        token
      })
      this.loadingClear = false
    },
    setDuplicateForm(item) {
      this.setLogsToEdit(item)
      this.editForm = !this.editForm
      // this.clearForm()
    },
    changeToDuplicate() {
      this.$emit("close");
    },
    handlePanelChange (panel) {
      const datepicker = document.getElementsByClassName('mx-time-header-title');
      if (panel === 'DATE') {
        datepicker.querySelector('.mx-icon-next-year').style.display = 'none'
      } else if (panel !== 'TIME') {
        datepicker.querySelector('.mx-icon-last-year').style.display = 'block'
        datepicker.querySelector('.mx-icon-next-year').style.display = 'block'
      }
    }
  },
  watch: {
    'goToPage' () {
      if (this.goToPage < 1 || this.goToPage > this.numberPages) {
        this.showGoToPageHelpText = true;
        this.disabledGoTo = true;
      } else {
        this.showGoToPageHelpText = false;
        this.disabledGoTo = false;
      }
    },
    "logsToEdit.message"() {
      this.logsToEdit.message !== null
        ? (this.disabled = true)
        : (this.disabled = false);
    },
    rangeDate() {
      this.rangeDate !== null
        ? (this.disabled = true)
        : (this.disabled = false);
    },
    rangeDateFinal() {
      this.rangeDateFinal !== null
        ? (this.disabled = true)
        : (this.disabled = false);
    },
  },
};
</script>
<style lang="scss" scoped>

.vs__clear, .mx-time-header {
  display: none;
}

.mx-time-content {
  padding-top: 25px;
}

.push-app__select {
  width: 190px;
}

.inputDate {
	.mx-input-wrapper {
		margin-top: -8px;

		input {
			width: 100% !important;
		}
	}
}

.mx-input-wrapper {
	width: 100% !important;
}

.push-web-responsive-note {
  width: 1224px;

  .buttons_action {
    display: flex;
    justify-content: flex-end;
  }

  .vs__selected-options {
    width: 250px;
    padding-right: 3px;
  }

  .v-expansion-panel-header {
    padding: 7px 10px 7px 3px;
  }
  .mx-input {
    display: flex;
    height: 44px;
    border: none;
    outline: none;
  }

  .filter--container {
    background: var(--white);
    border-radius: 4px;
    margin-bottom: 3.125rem;
    padding: 1.375rem;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    height: 88px;

    .inputDate {
      width: 280px;
      display: flex !important;
      justify-content: center;
      border: 2px solid var(--grey-day-030);
      height: 48px;
      padding: 7px;
      margin-right: 20px;
      border-radius: 4px;
      padding-left: 0;
      border-radius: 4px !important;

      .mx-input-wrapper {
        padding-left: 0;
        font-family: "DM Sans Regular", sans-serif;
				
					input {
						width: 250px !important;
					}
				.removeBorder {
					min-width: 100% !important;
					width: 100% !important;
				}

      }

      input {
        padding-left: 10px;
      }

      img {
        opacity: 0.5;
      }
    }

    .inputWidth {
      width: 250px;
    }

    label:focus-within {
      border: 2px solid var(--grey);
    }
    .button-wrapper {
      display: flex;
      justify-content: flex-end;

      &--text {
        display: flex;
        align-items: center;
      }

      button {
        background: var(--dark-red);
        border: none;
        border-radius: 4px;
        color: var(--white);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: var(--dm-sans-medium);
        font-size: 1rem;
        padding: 0.875rem;
        min-height: 48px;
        width: 130px;

        img {
          margin-right: 0.875rem;
        }
      }

      button:disabled {
        background: #dddddd;
        cursor: not-allowed;
      }
    }
  }

  .b-4 {
    border: 2px solid var(--grey-day-030);
    border-radius: 4px;
  }

  .h-48 {
    height: 48px;
  }

  .vs__dropdown-toggle {
    border: none !important;
  }

  .vs__search {
    display: flex;
    align-items: center;
    padding: 7px;
    color: var(--dark-grey)
  }

  
  .iconStyle {
    width: 20px;
    height: 20px;
    background: transparent;
  }

  .borderLeft {
    height: 49px;
    max-width: 3px !important;
    width: 13px;
    background-color: var(--green);
    margin: 0 5px;
    position: absolute;
  }

  .v-expansion-panel--active .borderLeft {
    height: initial !important;
    // max-width: 3px !important;
    transition: 0.3s;
    width: 4px;
    background-color: var(--green);
    margin: 0px 5px;
    position: absolute;
    top: 9px;
    bottom: 9px;
  }
}

.v-application .widthResponsive {
  width: 10%;
  margin-left: 50px;
}

.inputMessageFilter {
  height: 48px;
  border: 2px solid var(--grey-day-030);
  border-radius: 4px;
  padding: 7px;
  margin-right: 20px;
}

.list-footer {
    background: var(--white);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem 2.625rem;
    margin: 80px 0 10px 0;
    height: 64px;
  }

  .v-pagination__navigation,
  .v-pagination__item {
    border: none;
    box-shadow: none;
  }

  .goToPage {
    &--text {
      font-size: 14px;
      font-family: var(--dm-sans-regular);
      color: var(--dark-grey);
      margin-right: 20px;
    }

    label {
      border: 2px solid var(--grey-day-030);
      background: var(--white);
      border-radius: 4px;
      box-sizing: border-box;
      max-width: 84px;
      width: 80px;
      padding: 10px;
      position: relative;

      input {
        width: 54px;
        font-size: 1rem;
        color: var(--grey);
        font-family: var(--dm-sans-regular);
      }

      button {
        position: absolute;
        border-radius: 50%;
        border: none;
        padding: 0;
        top: 11px;
        right: 8px;
        background: var(--grey);
        cursor: pointer;

        i {
          color: var(--white);
          font-size: 1.25rem;
        }
      }

      button:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }

    &--helptext {
      font-family: var(--dm-sans-regular);
      position: absolute;
      font-size: 12px;
      width: 120px;
      text-align: center;
      top: -55px;
      left: -24px;
      background: var(--dark-red);
      padding: 8px;
      color: var(--light-grey);
      border-radius: 4px;
    }

    .--hide-helptext {
      display: none;
    }

    .--show-helptext {
      display: block;
    }
  }


@media screen and (max-width: 1377px) {
  .responsiveItemName {
    display: flex;
    align-items: flex-start;
  }

  .inputWidth {
    width: 100% !important;
  }

  .v-application {
    .widthResponsive {
      margin-top: 0;
    }
    
    .push-web-responsive-note {
      width: 830px;

      .filter--container {
        height: initial;

        &.d-flex {
          display: grid !important;
          grid-template-columns: 1fr 1fr;
          gap: 8px;
        }

        .button-wrapper {
          grid-row: 3;
          grid-column: 1 / -1;
          justify-self: flex-start;
        }
        .inputDate {
          width: 100%;
          grid-row: 2;

					.mx-input-wrapper {
						width: 100% !important;
					}
        }
        .inputMessageFilter {
          grid-column-start: 1;
          grid-column-end: 3;
          grid-row: 1;
          grid-template-columns: 1fr;
          margin-right: 0px;
        }
      }

      .v-expansion-panel--active {
        .borderLeft {
          height: 320px;
        }
      }
    }
  }

  .push-web-responsive-note {


    .widthResponsive {
      width: 200px;
    }
    .inputDate {
      width: 114px;
    }
    .imgResponsive {
      display: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Contents/ScheduleWeb/Schedule.vue